module.exports = __webpack_public_path__ + "img/stackslash-69.bc6b2795.jpg";